/**
* Component PageLink
*
* Link to navigate in the other page
*
* Props : 
* - text (String) : text on the button
* - url (String) : url on the new page
* - background (String) : background on the button. By default the parameter is brown
*
* Method : 
* - backgroundClass (computed) : if the value of the props "background" is blue. "BackgroundClass" call the css "link_brown". Otherwise he calls "link_blue"
* - handleClick (methods) : change to new page when the button is clicked
* 
*/

<template>
  <button class="link_container" :class="backgroundClass" @click="handleClick" data-aos="fade-in" data-aos-duration="900" data-aos-easing="ease-in-out"  data-aos-once="true">
    {{ text }}
  </button>
</template>

<script>

export default {
  name: "PageLink", 
  props: {
    text:String,
    url:String,
    background:{
      type:String,
      default:"brown"
    },
  },
    computed: {
    backgroundClass() {
      return this.background === "blue" ? "link_blue" : "link_brown";
    },
  },
  methods: {
     handleClick() {
    if (this.url.startsWith('http')) {
      // Lien externe → on redirige avec window.location
      window.open(this.url, '_blank'); // ou juste window.location.href = this.url;
    } else {
      // Lien interne → route Vue
      this.$router.push(this.url);
    }
  }
},
}
</script>

<style lang="scss">
@import "../assets/styles/_variables.scss";

.link_blue{
  color: white;
  background: $background-button-action-blue
}

.link_brown{
  background: $background-button-action-brown;
}

</style>